import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { Instagram, Facebook, YouTube, Phone, Email } from "@mui/icons-material";
import image from "../../assets/updatedBannerImage/updatedbannerImage2.png";

const socialLinks = [
  { Icon: Instagram, url: "https://www.instagram.com/reefindia.official/profilecard/?igsh=ODl3NHNoMGU2Y2o3" },
  {
    Icon: Facebook,
    url: "https://www.facebook.com/reefindia.official?rdid=LKYNzBVSUtMb3Cul&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15nXAjbts5%2F",
  },
  { Icon: YouTube, url: "https://www.youtube.com/thehabitatstrust/" },
  { Icon: Phone, url: "tel:+9194479 83004" },
  { Icon: Email, url: "mailto:reefindia1@gmail.com" },
];


const OverviewSection = () => {
  return (
    <Box
      sx={{
        minHeight: { md: "80vh", xs: "50vh" },
        width: "100%",
        overflowX: "hidden",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        color: "#fff",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Right-side content over image */}
      <Box
        sx={{
          position: { xs: "static", md: "absolute" },
          top: 0,
          right: 0,
          width: { xs: "100%", md: "50%" },
          height: { xs: "100%", md: "100%" },
          px: { xs: 2, md: 10 },
          py: { xs: 4, md: 6 },
          mr: { md: 10, xs: 0 },
          boxSizing: "border-box",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          flexDirection: "column",
          background: {
            xs: "rgba(0, 0, 0, 0.6)",
            md: "transparent",
          },
        }}
      >
        {/* Scrollable inner content */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "600px",
            maxHeight: { xs: "400px", md: "600px" },
            overflowY: "auto",
            // pr: 2,
            scrollBehavior: "smooth",
            px: { xs: 0, md: 0 }, // add side padding on mobile
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "20px", md: "36px" },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              letterSpacing: "2px",
              mb: { xs: 2, md: 3 },
              textTransform: "uppercase",
              color: "#fff",
            }}
          >
            About Us
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              lineHeight: 1.8,
              mb: { xs: 2, md: 3 },
              fontFamily: "Montserrat, sans-serif",
              color: "#ccc",
            }}
          >
            The Research and Environmental Education Foundation (REEF) is a not-for-profit, non-governmental organization dedicated to advancing environmental stewardship through research, education, and community engagement.
          </Typography>

          {[...[
            "Rooted in principles of ecological integrity and social equity, REEF works to promote the sustainable management of natural resources, with a strong focus on coastal and marine ecosystems.",
            "We collaborate with educational institutions, local communities, policymakers, and conservation networks to design inclusive programs that support biodiversity protection, climate resilience, and sustainable livelihoods.",
            "Through field research, capacity-building workshops, citizen science, and youth engagement, REEF seeks to nurture informed environmental leadership and cultivate a culture of conservation across generations.",
            "Guided by a vision of harmony between people and nature, REEF is committed to creating pathways for long-term ecological and social resilience in some of India’s most ecologically sensitive and culturally rich landscapes, particularly in the Lakshadweep archipelago and other coastal regions."
          ]].map((para, i) => (
            <Typography
              key={i}
              variant="body1"
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: 1.8,
                mb: { xs: 2, md: 3 },
                fontFamily: "Montserrat, sans-serif",
                color: "#ccc",
              }}
            >
              {para}
            </Typography>
          ))}

          <Button
            variant="outlined"
            sx={{
              color: "#344246",
              backgroundColor: "#f5f5f5",
              borderColor: "#ccc",
              borderRadius: "30px",
              px: 3,
              py: 1.2,
              fontSize: "12px",
              fontWeight: "bold",
              fontFamily: "Montserrat, sans-serif",
              letterSpacing: "2px",
              display: "flex",
              alignItems: "center",
              mt: 2,
              transition: "all 0.3s ease",
              "& .MuiBox-root": {
                backgroundColor: "#fff",
                color: "#000",
                width: "26px",
                height: "26px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                mr: 1.5,
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                flexShrink: 0,
              },
              "&:hover": {
                backgroundColor: "#e0e0e0",
                color: "#222",
                borderColor: "#bbb",
              },
            }}
          >
            <Box>➤</Box> Learn More
          </Button>
        </Box>

      </Box>

      {/* Fixed Vertical Social Icons (Desktop Only) */}
      <Box
        sx={{
          position: "fixed",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "#1a1a1a",
          borderRadius: "30px 0 0 30px",
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          gap: 1,
          py: 1.5,
          px: 1,
          zIndex: 1000,
        }}
      >
        {socialLinks.map(({ Icon, url }, i) => {
          const isExternal = url.startsWith("http");

          return (
            <IconButton
              key={i}
              component="a"
              href={url}
              {...(isExternal
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              sx={{ color: "#fff", p: 1 }}
            >
              <Icon fontSize="small" />
            </IconButton>
          );
        })}
      </Box>;
    </Box>
  );
};

export default OverviewSection;
